export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/cartEmpty.png?d77fc58de1b300b9d6eae271c287dca6";